(function () {
    'use strict';

    angular
        .module('app')
        .factory('EntitiesService', EntitiesService);

    EntitiesService.$inject = ['$http', '$q', 'UrlService', 'DataService', 'Upload'];

    function EntitiesService($http, $q, UrlService, DataService, Upload) {
        var resourceUrl = 'entity';
        var service = {};

        angular.extend(service, DataService(resourceUrl));

        angular.extend(service, {
            query: query,
            save: save,
            getUserSummary: getUserSummary,
            multiDelete: multiDelete,
            multiCopy: multiCopy,
            getContacts: getContacts,
            getPreviewText: getPreviewText,
            getPreExportReport: getPreExportReport,
            exportEntities: exportEntities,
            validateImportEntities: validateImportEntities,
            importEntities: importEntities,
            getDefaultSMSTemplate: getDefaultSMSTemplate,
            getDefaultEmailTemplate: getDefaultEmailTemplate
        });

        return service;

        function query(queryParams) {
            var queryString = '';

            if (!angular.isUndefined(queryParams)) {
                var pars = angular.copy(queryParams);
                var searchFields = pars.searchFields;
                var orderFields = pars.orderFields;
                delete pars.searchFields;
                delete pars.orderFields;

                queryString = service.convertQueryParams(pars);
                
                if (!angular.isUndefined(queryParams.searchFields) && queryParams.searchFields !== null) {
                    angular.forEach(Object.keys(queryParams.searchFields), function (searchFieldKey) {
                        queryString += queryString.length > 0 ? '&' : '?';
                        queryString += 'Filter[' + searchFieldKey + ']=' + queryParams.searchFields[searchFieldKey];
                    });
                }

                if (!angular.isUndefined(queryParams.orderFields) && queryParams.orderFields !== null) {
                    angular.forEach(queryParams.orderFields, function (orderField) {
                        queryString += queryString.length > 0 ? '&' : '?';
                        queryString += 'Sort[' + orderField.Name + ']=' + orderField.Order;
                    });
                }
            }     

            return DataService(resourceUrl).query(queryString);
        }

        function save(entity, files) {
            var entityData = angular.copy(entity);
            entityData.EntityTemplateId = entityData.EntityTemplate.Id;
            entityData.EntityType = entityData.EntityTemplate.EntityType;
            delete entityData.EntityTemplate;

            // If there are files to attach send as multipart form, otherwise send as json content.
            if (angular.isDefined(files) && files !== null && Object.keys(files).length > 0)
            {
                if (entity.Id || entity.id) {
                    var id = entity.Id ? entity.Id : entity.id;
                    return Upload.upload({
                        url: UrlService.getWebAPIUrl() + '/' + resourceUrl + '/' + id, data: { files: files, 'jsonData': angular.toJson(entityData) },
                        method: 'PUT'
                    })
                        .then(function (response) {
                            return response.data;
                        }, function (response) {
                            return $q.reject(response);
                        });
                } else {
                    return Upload.upload({ url: UrlService.getWebAPIUrl() + '/' + resourceUrl + '/', data: { files: files, 'jsonData': angular.toJson(entityData) }, method: 'POST' })
                        .then(function (response) {
                            return response.data;
                        }, function (response) {
                            return $q.reject(response);
                        });
                }
            }
            else {
                return DataService(resourceUrl).save(entityData);
            }


            return DataService(resourceUrl).save(entityData);
        }

        function getUserSummary() {
            return $http.get(UrlService.getWebAPIUrl() + '/entity/?usersummary').then(
                function ok(response) { return response.data; },
                function error(response) { return $q.reject(response); });
        }

        function multiDelete(entityIds) {
            return $http.post(UrlService.getWebAPIUrl() + '/entitydelete', entityIds)
                .then(function (response) {
                    // OK
                }, function (response) {
                    return $q.reject(response);
                });
        }

        /**
         * Get the Pre-Export Report for the specified entity template
         *
         * @param {int} entityTemplateId - Id of entity template which will be used for the export
         * @return {promise} Promise resolves an {object} representing the pre-export report
         */
        function getPreExportReport(entityTemplateId) {
            var requestUrl = UrlService.getWebAPIUrl() + '/PreEntityExportReport/?entityTemplateId=' + entityTemplateId;
            return $http.get(requestUrl).then(function ok(response) {
                return response.data;
            });
        }

        /**
         * Export the specified entities.
         *
         * When exporting either entityIds or entityTemplateId must be supplied, both can't be specified for a single request.
         *
         * @param {array} entityIds - An array of entity ids for the entities to be exported.
         * @param {int} entityTemplateId - The entity template for which the entities or blank template are to be exported.
                                            By Default all entities for the entity template will be exported unless blankTemplate is set to true.
         * @param {bool} blankTemplate - Should the blank template be returned for the entity template. This requires entityTemplateId to be set.
         * @param {bool} includeLookups - Should the lookup worksheets be included for List and Linked entities
         * @param {bool} transpose - Should the embedded/linked entities be transposed
         * @param {array} fieldsToExport - List of paths for fields that are to be exported
         *
         * @return {promise} A promise resolved once the entity export is complete, rejects with a http response if there was a server-side error.
         */
        function exportEntities(entityIds, entityTemplateId, blankTemplate, includeLookups, transpose, fieldsToExport) {
            var requestUrl = UrlService.getWebAPIUrl() + '/entityexport/';
            var queryString = '';

            if (!_.isNil(entityIds)) {
                angular.forEach(entityIds, function (entityId) {
                    queryString += queryString.length > 0 ? '&' : '?';
                    queryString += 'entityIds=' + entityId;
                });
            }

            if (!_.isNil(entityTemplateId)) {
                queryString += queryString.length > 0 ? '&' : '?';
                queryString += 'entityTemplateId=' + entityTemplateId;
            }

            if (!_.isNil(blankTemplate) && blankTemplate) {
                queryString += queryString.length > 0 ? '&' : '?';
                queryString += 'blankTemplate=' + blankTemplate;
            }

            if (!_.isNil(includeLookups) && includeLookups) {
                queryString += queryString.length > 0 ? '&' : '?';
                queryString += 'includeLookups=' + includeLookups;
            }

            if (!_.isNil(transpose) && transpose) {
                queryString += queryString.length > 0 ? '&' : '?';
                queryString += 'transpose=' + transpose;
            }

            if (!_.isNil(fieldsToExport) && fieldsToExport.length > 0) {
                _.forEach(fieldsToExport, function (fieldToExport) {
                    queryString += queryString.length > 0 ? '&' : '?';
                    queryString += 'fieldsToExport=' + fieldToExport;
                });
            }

            var req = {
                method: 'GET',
                url: requestUrl + queryString,
                headers: { 'Content-Type': 'application/json' },
                responseType: 'arraybuffer'
            };

            return $http(req);
        }

        /**
         * Validates the Import process for the specified entities.
         *
         * @param {int} - entityTemplateId - The entity template for which the entities are to be imported
         * @param {file} importData - A XLSX file containing entity data which is to be imported
         *
         * @return {promise} A promise resolving to a validation report once complete, rejects with a http response if there was a server-side error.
         */
        function validateImportEntities(entityTemplateId, importData) {
            var requestUrl = UrlService.getWebAPIUrl() + '/validateentityimport/?entityTemplateId=' + entityTemplateId;

            return Upload.http({
                headers: {
                    'Content-Type': 'application/octet-stream',
                    'Content-Disposition': 'form-data; name="file"; filename="' + file.FileName + '"'
                },
                url: requestUrl,
                data: importData.File
            });
        }

        /**
         * Import the specified entities.
         *
         * @param {int} - entityTemplateId - The entity template for which the entities are to be imported
         * @param {file} importData - A XLSX file containing entity data which is to be imported
         * @param {array} entitiesToExclude - A list of ids for entities which are not to be updated. This is ignored for add/delete operations
         *
         * @return {promise} A promise resolved once the entity import is complete, rejects with a http response if there was a server-side error.
         */
        function importEntities(entityTemplateId, importData, entitiesToExclude) {
            var requestUrl = UrlService.getWebAPIUrl() + '/entityimport/?entityTemplateId=' + entityTemplateId;

            if (!_.isNil(entitiesToExclude)) {
                angular.forEach(entitiesToExclude, function (entityId) {
                    requestUrl += '&excludeEntityIds=' + entityId;
                });
            }

           return Upload.http({
                headers: {
                    'Content-Type': 'application/octet-stream',
                    'Content-Disposition': 'form-data; name="file"; filename="' + file.FileName + '"'
                },
                url: requestUrl,
                data: importData.File
            });
        }

        /**
         * Create copies of the specified entities.
         *
         * @param {array} entityIds - An array of entity ids for the entities to be copied.
         * @return {promise} A promise resolved once the entity copy is complete, rejects with a http response if there was a server-side error.
         */
        function multiCopy(entityIds) {
            return $http.post(UrlService.getWebAPIUrl() + '/entitycopy', entityIds);
        }

        /**
         * Returns a list of contacts for the specified entity.
         *
         * @param {int} entityId - Id of entity for which the contacts will be retrieved.
         * @param {bool} includeReferenceContacts - Should the reference contacts also be retrieved, these are used for the To addresses when in 'multiple from address' mode.
         * @param {array} usageTypes - List of usage types that are to be returned. E.g. Email, SMS, Fax. Optional.
         *
         * @return {promise} Promise resolves returning a list of email contacts upon success.
         */
        function getContacts(entityId, includeReferenceContacts, usageTypes) {
            var requestUrl = UrlService.getWebAPIUrl() + '/entity/' + entityId + '/Contacts';
            var queryString = '';

            if (!_.isNil(includeReferenceContacts)) {
                queryString += '?includereferencecontacts=' + includeReferenceContacts;
            }

            if (!_.isNil(usageTypes)) {
                angular.forEach(usageTypes, function (usageType) {
                    queryString += queryString.length > 0 ? '&': '?';
                    queryString += 'usagetypes=' + usageType;
                });
            }

            return $http.get(requestUrl + queryString).then(
                function ok(response) { return response.data; }, null);
        }

        /**
         * Get the "Preview Text" for the specified entity.
         * NB: THIS SKIPS SECURITY CHECKS
         *
         * @param {int} entityId - Id of entity to fetch preview text for.
         * @return {promise} Promise resolves an {object} representing an entity with properties: {number} Id, {string} PreviewNameText and {string} PreviewDescriptionText.
         */
        function getPreviewText(entityId) {
            var requestUrl = UrlService.getWebAPIUrl() + '/entity/' + entityId + '?SkipSecurity=true&PreviewTextOnly=true';
            return $http.get(requestUrl).then(function ok(response) {
                return response.data;
            });
        }

        /**
         * Get the default SMS Template for the specified entity.
         *
         * @param {int} entityId - Id of entity for which the SMS Template will be retrieved.
         * @return {promise} Promise resolves an {object} representing a sms template.
         */
        function getDefaultSMSTemplate(entityId) {
            var requestUrl = UrlService.getWebAPIUrl() + '/entity/' + entityId + '/defaultsmstemplate';
            return $http.get(requestUrl).then(function ok(response) {
                return response.data;
            });
        }

        /**
         * Get the default Email Template for the specified entity.
         *
         * @param {int} entityId - Id of entity for which the Email Template will be retrieved.
         * @return {promise} Promise resolves an {object} representing a email template.
         */
        function getDefaultEmailTemplate(entityId) {
            var requestUrl = UrlService.getWebAPIUrl() + '/entity/' + entityId + '/defaultemailtemplate';
            return $http.get(requestUrl).then(function ok(response) {
                return response.data;
            });
        }
    }
})();
